import React from 'react';
import {RouteComponentProps, Redirect} from 'react-router-dom'//yarn add @types/react-router-dom
import useReactRouter from 'use-react-router';


interface RCProps extends RouteComponentProps<{gid?:string}> {
	
}

interface Props {
    set(gid:string):void,
}

const Enter = (props:Props)=> {
    const rcp:RCProps = useReactRouter();

    if( rcp.match.params.gid ){
        props.set(rcp.match.params.gid);
    }

    return (
        <Redirect to="/"/>
    );
}

export default Enter;
